import { useEffect, useState } from 'react';
import sanityClient from '../../client';

import './index.css';

export const ShowsTable = () => {
    const [showData, setShowData] = useState([]);
    const [width, setWidth] = useState(window.innerWidth);
    const [activeIndex, setActiveIndex] = useState(null);

    const fetchData = async () => {
        try {
            const query = `*[_type == 'shows'][0]`;
            const result = await sanityClient.fetch(query);
            console.log(result.show);
            setShowData(result.show);
        } catch (error) {
            console.error(error);
        }
    };

    const handleWindowResize = () => {
        setWidth(window.innerWidth);
    }

    const handleAccordionClick = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        }
    }, []);

    const isMobile = width <= 768;

    return (
        <>
            <div className='shows-table'>
                <div className='description'>
                    <h1>Shows</h1>
                    <p>
                        Show dates, locations, venues, and ticket portals are available in the shows table below.
                    </p>
                </div>
                {!isMobile ? (
                    <table>
                    <thead>
                        <tr>
                            <th><h1>Show Date</h1></th>
                            <th><h1>City</h1></th>
                            <th><h1>Venue</h1></th>
                            <th><h1>Ticket Link</h1></th>
                        </tr>
                    </thead>
                    <tbody>
                        {showData && showData.map((show, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        {show.date ? new Date(show.date.replace(/-/g, '/')).toLocaleDateString('en-US', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        }) : <p>TBD</p>
                                        }
                                    </td>
                                    <td>{show.city ? show.city : <p>TBD</p>}</td>
                                    <td>{show.venue ? show.venue : <p>TBD</p>}</td>
                                    <td>
                                        {show.link !== undefined ? (
                                            <p>
                                                <a href={show.link} target='_blank' rel="noopener noreferrer">Ticket Link</a>
                                            </p>
                                        ) : (
                                            <p>No tickets at this time</p>
                                        )}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                ) : (
                    <div className="accordion">
                        {showData.map((show, index) => (
                            <div key={index} className={`accordion-item`}>
                                <div className="accordion-header" onClick={() => handleAccordionClick(index)}>
                                    <span className='city'>{show.city}</span>
                                    <span className={`accordion-icon ${activeIndex === index ? 'minus' : 'plus'}`}>
                                        {activeIndex === index ? '\u2212' : '\u002B'}
                                    </span>
                                </div>
                                <div className={`accordion-content ${activeIndex === index ? 'active' : ''}`}>
                                    <span>
                                        {new Date(show.date.replace(/-/g, '/')).toLocaleDateString('en-US', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        })}
                                    </span>
                                    <br />
                                    <br />
                                    <span>{show.venue}</span>
                                    <br />
                                    {show.link !== undefined ? (
                                        <p>
                                            <a href={show.link} target="_blank" rel="noopener noreferrer">
                                            Ticket Link
                                            </a>
                                        </p>
                                    ) : (
                                        <p>No tickets at this time</p>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    )
}